var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('OzDropdownButton',{class:[
    !_vm.isMap && {
      'hover-hover:hover:bg-surface-filter-button-hover-light': _vm.backgroundLuminance === 'light',
      'hover-hover:hover:bg-surface-filter-button-hover-dark': _vm.backgroundLuminance === 'dark',
    },
    _vm.isMap && {
      'hover-hover:hover:bg-grey-200': _vm.colorScheme === 'light',
      'hover-hover:hover:bg-grey-600': _vm.colorScheme === 'dark',
    },
  ],attrs:{"id":"surface-filter-dropdown-button","dir":_vm.dir,"size-preset":_vm.OzDropdownButtonSizePreset.H32px,"color-scheme":_vm.xFilterPopover ? _vm.OzDropdownButtonColorScheme.SecondaryClearActive : _vm.OzDropdownButtonColorScheme.SecondaryClear,"dark-mode":_vm.isMap ? _vm.colorScheme === 'dark' : _vm.backgroundLuminance === 'dark',"start-icon-name":_vm.isCustomFilter ? 'filter_filled' : 'filter_outline',"text":_vm.dropdownButtonText,"title":_vm.__('Filter posts'),"aria-label":_vm.__('Filter posts')},on:{"click":_vm.showFilterPopover}})
}
var staticRenderFns = []

export { render, staticRenderFns }